import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  PoliciesAPI,
  RepositoryAPI,
  NovoCotadorAPI,
  PolicyHolderAPI
} from '@services/api';

import rootReducer from './combinedReducers';

const API = { PoliciesAPI, RepositoryAPI, NovoCotadorAPI, PolicyHolderAPI };
const middlewares = [thunk.withExtraArgument({ ...API })];

const persistConfig = {
  key: '@process:root',
  storage,
  whitelist: ['processes', 'login', 'user']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const logger = createLogger({
  collapsed: true
});

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);
const persistor = persistStore(store);

export { store, persistor };
